export default __webpack_public_path__ + "static/1460-8e368c09c46d85fea0aaea0422efdcb0.gif";